import { render, staticRenderFns } from "./hytbbj.vue?vue&type=template&id=60da3bb4&scoped=true&"
import script from "./hytbbj.vue?vue&type=script&lang=js&"
export * from "./hytbbj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da3bb4",
  null
  
)

export default component.exports